/**
 * Состояние мини-гида: автозапуск один раз на экран + ручной перезапуск.
 *
 * `key` — уникальный идентификатор гида (один на экран); по нему хранится флаг
 * «уже видел» в localStorage. `ready` — гид автозапустится, как только данные
 * экрана отрисованы (целевые блоки появились в DOM). Кнопка перезапуска вызывает
 * `start()` и работает независимо от флага.
 */
import { useEffect, useRef, useState } from 'react'

const SEEN_PREFIX = 'onboarding-tour-seen:'

export function useOnboardingTour(key: string, ready = true) {
  const [open, setOpen] = useState(false)
  const autoFired = useRef(false)

  useEffect(() => {
    if (!ready || autoFired.current) return
    autoFired.current = true
    let seen = false
    try {
      seen = localStorage.getItem(SEEN_PREFIX + key) === '1'
    } catch {
      // localStorage недоступен (приватный режим и т.п.) — просто покажем гид.
    }
    if (!seen) {
      try {
        localStorage.setItem(SEEN_PREFIX + key, '1')
      } catch {
        // запись недоступна — не критично, гид всё равно откроется один раз за сессию.
      }
      setOpen(true)
    }
  }, [ready, key])

  return {
    open,
    start: () => setOpen(true),
    close: () => setOpen(false),
  }
}
